import React, { Fragment, useEffect } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
// import FileContent from './FileContent';
import { Card, Tabs } from "antd";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Container } from "reactstrap";
import { useAPIUser } from "../../../_helper/User/UserProvider";
import ApprovalFlow from "./OrganisationContent/ApprovalFlow";
import Branches from "./OrganisationContent/Branches";
import Categories from "./OrganisationContent/Categories";
import Gst from "./OrganisationContent/Gst";
import Members from "./OrganisationContent/Members";
import OrganisationProfile from "./OrganisationContent/OrganisationProfile";
import TermsAndConditions from "./OrganisationContent/TermsAndConditions";
import { LogEvents, LoggerContext } from "../../../context/logging";
const { TabPane } = Tabs;

const FileManagerContain = () => {
  const logger = React.useContext(LoggerContext);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    logger.log(LogEvents.organizationSettings, {});
  }, []);

  return (
    <Fragment>
      <Container fluid={true}>
        <Card>
          <Tabs
            onChange={(e) => {
              if (e == 1) {
                logger.log(LogEvents.organizationProfile, {});
              }
              if (e == 2) {
                logger.log(LogEvents.organizationBranches, {});
              }
              if (e == 4) {
                logger.log(LogEvents.organizationTermsAndConditions, {});
              }
              if (e == 5) {
                logger.log(LogEvents.organizationGstDetails, {});
              }
              if (e == 6) {
                logger.log(LogEvents.organizationMembers, {});
              }
              if (e == 7) {
                logger.log(LogEvents.organizationApprovalFlow, {});
              }
            }}
            defaultActiveKey={searchParams?.get("tab") ?? "2"}
            type="card"
          >
            {/* <TabPane tab="Organisation Profile" key="1">
              <OrganisationProfile />
            </TabPane> */}
            <TabPane tab="Organisation Profile" key="2">
              <Branches />
            </TabPane>
            {/* <TabPane tab="Categories" key="3">
              <Categories />
            </TabPane> */}
            <TabPane tab="Terms and Conditions" key="4">
              <TermsAndConditions />
            </TabPane>
            <TabPane tab="GST" key="5">
              <Gst />
            </TabPane>
            <TabPane tab="Members" key="6">
              <Members />
            </TabPane>
            <TabPane tab="Approval Flow" key="7">
              <ApprovalFlow />
            </TabPane>
            {/* <TabPane tab="Logs" key="8">
              <Logs />
            </TabPane> */}
          </Tabs>
        </Card>
        {/* <Row>
          <FileSideBar
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
          <Col xl="9" md="12" className="xl-70 box-col-8">
            <div className="file-content">
              <Card>{renderTab(selectedTab)}</Card>
            </div>
          </Col>
        </Row> */}
      </Container>
    </Fragment>
  );
};
export default FileManagerContain;
